import React, { useState } from "react"
import { Modal, Box, Typography, Grid, Card, CardActionArea, IconButton, Fade } from "@mui/material"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"

interface Document {
    id: number
    name: string
}

const dummyDocuments: Document[] = [
    { id: 1, name: "Invoice_001.pdf" },
    { id: 2, name: "Bill_of_Lading.pdf" },
    { id: 3, name: "Packing_List.pdf" },
    { id: 4, name: "Delivery_Note.pdf" },
]

interface JobDocumentsProps {
    open: boolean
    onClose: () => void
}

const JobDocuments: React.FC<JobDocumentsProps> = ({ open, onClose }) => {
    const [previewDoc, setPreviewDoc] = useState<Document | null>(null)

    const handlePreviewToggle = (doc: Document) => {
        setPreviewDoc(previewDoc?.id === doc.id ? null : doc)
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box
                sx={{
                    bgcolor: "primary.main",
                    p: 3,
                    borderRadius: 2,
                    maxWidth: 800,
                    width: "90%",
                    boxShadow: 24,
                    maxHeight: "60vh",
                    overflowY: "auto",
                    alignSelf: "center",
                }}
            >
                <Typography variant="h5" align="center" color="white" gutterBottom>
                    Job Documents
                </Typography>
                <Grid container spacing={2}>
                    {dummyDocuments.map((doc) => (
                        <Grid item xs={6} key={doc.id}>
                            <CardActionArea onClick={() => handlePreviewToggle(doc)}>
                                <Box sx={{ p: 2, display: "flex", flexDirection: "column", alignItems: "center" }}>
                                    <PictureAsPdfIcon sx={{ fontSize: 40, mb: 1 }} />
                                    <Typography variant="body1" align="center" gutterBottom>
                                        {doc.name}
                                    </Typography>
                                </Box>
                            </CardActionArea>
                        </Grid>
                    ))}
                </Grid>

                {previewDoc && (
                    <Fade in={true}>
                        <Box sx={{ mt: 2, p: 2, borderRadius: 2, boxShadow: 4 }}>
                            <Typography variant="h6" align="center" gutterBottom>
                                Previewing: {previewDoc.name}
                            </Typography>
                            <Typography variant="body2" align="center">
                                [Document content preview goes here]
                            </Typography>
                        </Box>
                    </Fade>
                )}
            </Box>
        </Modal>
    )
}

export default JobDocuments
